import { OcpsPolicy, isOcpsPolicyEnabled } from "owa-ocps-policy-store";
import { isPrivacyRoamingEnabled } from "./isPrivacyRoamingEnabled";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { isOcpsPolicyEnabled as isOwsPrimeOcpsPolicyEnabled, PrivacyPolicySettingId, } from "owa-owsprime-policies-store";

export const getOptionalExperiencesPolicy = (): boolean => {
    if (!isPrivacyRoamingEnabled()) {
        return true;
    }
    
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    
    return isOwsPrimeOcpsPolicyEnabled(PrivacyPolicySettingId.OptionalConnectedExperiences, mailboxInfo, () => isOcpsPolicyEnabled(OcpsPolicy.OptionalConnectedExperiences, true /* enabledIfUndefined */, mailboxInfo));
};
